'use client';
import { jsx } from 'react/jsx-runtime';
import { IntlProvider } from 'react-intl';
import loggger from '@repo/logger';

function ReactIntlProvider({ children, defaultLocale, lang, messages }) {
    return /*#__PURE__*/ jsx(IntlProvider, {
        defaultLocale: defaultLocale,
        locale: lang,
        messages: messages,
        onError: (err)=>{
            if (err.code === "MISSING_TRANSLATION") {
                loggger.warn("Missing translation", err.message);
                return;
            }
            throw err;
        },
        children: children
    });
}

export { ReactIntlProvider };
